export { default } from './PressArticleCard';
